/* Carbon Society Co. - site interactions: sticky header state, navigation drawer,
 * single-open accordions on small screens, product image zoom. No dependencies.
 * Every feature checks for its markup first, so this file is safe on every page.
 */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header: solid navy once scrolled; fixed over the hero on the homepage ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var overlay = header.classList.contains('header--overlay');
    var ann = document.querySelector('.ticker');
    var root = document.documentElement;
    if (overlay) root.classList.add('js-header-fixed');
    var ticking = false;
    var update = function () {
      var y = window.scrollY || 0;
      header.classList.toggle('is-scrolled', y > 24);
      if (overlay) {
        var top = ann ? Math.max(0, ann.getBoundingClientRect().bottom) : 0;
        root.style.setProperty('--header-top', top + 'px');
      }
      ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
    /* Sticky offset used by the product gallery, build bar and cart summary */
    var setOffset = function () { root.style.setProperty('--cc-top', (header.offsetHeight + 16) + 'px'); };
    setOffset(); window.addEventListener('resize', setOffset);
  }

  /* ---------- Navigation drawer ---------- */
  var menu = document.querySelector('[data-menu]');
  if (menu) {
    var toggle = menu.querySelector('summary');
    var panel = menu.querySelector('.drawer-panel');
    var lastFocus = null, closing = false;
    var setState = function (open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };
    var close = function () {
      if (!menu.open || closing) return;
      if (reduce) { menu.open = false; return; }
      closing = true;
      menu.classList.add('is-closing');
      setTimeout(function () { menu.classList.remove('is-closing'); menu.open = false; closing = false; }, 230);
    };
    menu.addEventListener('toggle', function () {
      setState(menu.open);
      if (menu.open) {
        lastFocus = document.activeElement;
        var first = panel.querySelector('input, a, button');
        if (first) setTimeout(function () { first.focus(); }, 40);
      } else if (lastFocus) { toggle.focus(); }
    });
    toggle.addEventListener('click', function (e) { if (menu.open) { e.preventDefault(); close(); } });
    menu.querySelectorAll('[data-menu-close]').forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); close(); }); });
    document.addEventListener('keydown', function (e) {
      if (!menu.open) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        var f = panel.querySelectorAll('a[href], button:not([disabled]), input, summary, [tabindex]:not([tabindex="-1"])');
        f = Array.prototype.filter.call(f, function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
    window.addEventListener('resize', function () { if (window.innerWidth >= 990 && menu.open) { menu.open = false; } });
  }

  /* ---------- Accordions: one open at a time on small screens ---------- */
  document.querySelectorAll('[data-accordion-group]').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.open || window.innerWidth >= 750) return;
      group.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
    }, true);
  });

  /* ---------- Product image: hover zoom (desktop) + smooth swap ---------- */
  var main = document.querySelector('.product__main');
  if (main && window.matchMedia('(hover: hover)').matches) {
    var img = main.querySelector('img');
    if (img) {
      main.addEventListener('mousemove', function (e) {
        var r = main.getBoundingClientRect();
        main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
      main.addEventListener('mouseenter', function () { main.classList.add('is-zoomed'); });
      main.addEventListener('mouseleave', function () { main.classList.remove('is-zoomed'); });
    }
  }
  if (main) {
    var mImg = main.querySelector('img');
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        document.querySelectorAll('[data-thumb]').forEach(function (o) { o.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
        if (!mImg || reduce) return;
        main.classList.add('is-loading');
        var done = function () { main.classList.remove('is-loading'); };
        mImg.addEventListener('load', done, { once: true });
        setTimeout(done, 600);
      });
    });
  }
  /* ---------- Below-the-fold background videos: load + play only near the viewport ---------- */
  var vids = document.querySelectorAll('video.js-lazy-video');
  if (vids.length) {
    var start = function (v) { if (reduce) { v.preload = 'metadata'; return; } v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if (!('IntersectionObserver' in window)) vids.forEach(start);
    else {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) start(e.target); else if (!e.target.paused) e.target.pause(); });
      }, { rootMargin: '300px 0px' });
      vids.forEach(function (v) { v.muted = true; vio.observe(v); });
    }
  }
})();
